module.exports = __webpack_public_path__ + "assets/version_history.2d5ffd41.svg";